import React, { useEffect, useState } from "react";
import { SplitInputWrapperProps, InputWrapper } from "../../functions";
import { EditorBoxProps } from "./interface";
import { Editor } from "@tinymce/tinymce-react";

const EditorInputBox: React.FC<EditorBoxProps> = (props) => {
  const { formProps, inputProps } = SplitInputWrapperProps(props);
  const { initValue, editorChange, ...rest } = inputProps;
  const [initialValue, setInitialValue] = useState("");

  const handleEditorChange = (e: any) => {
    if (editorChange) {
      editorChange(e);
      setInitialValue(e)
    }
  };

  useEffect(() => {
    setInitialValue(initValue)
  }, [])
  return (
    <InputWrapper {...formProps}>
      <Editor
        {...rest}
      
        apiKey={import.meta.env.VITE_REACT_APP_TINYMCE_KEY ?? ''}
        value={initialValue}
        onEditorChange={handleEditorChange}
        init={{
          forced_root_block_attrs: {
            'style': 'font-size: 14px;',
            },
          menubar: false,
          plugins: 'lists image fullscreen wordcount code link ',
          toolbar: `bold italic underline forecolor removeformat numlist bullist alignleft aligncenter alignright alignjustify outdent indent | lineheight image link fullscreen code`,
          font_size_formats: "8px 9px 10px 11px 12px 14px 18px 24px 36px",
          toolbar_mode: 'sliding',
          line_height_formats: "1 1.2 1.4 1.5 1.6 1.8 2.0 3.0",
          // content_style: "body {font-size: 18px;}",
          image_dimensions: true,
          images_upload_credentials: true,
          automatic_uploads: true,
          file_picker_types: 'image', 
          images_file_types: 'png,jpg,svg',
        
          images_upload_handler: async (blobInfo: any) => {
            return new Promise((resolve, reject) => {
              const fileReader: any = new FileReader()
              fileReader.readAsDataURL(blobInfo.blob())
              fileReader.onload = () => {
                resolve(fileReader.result)
              }
              fileReader.onerror = (e: any) => {
                reject(e)
              }
            })
          }
        }} />
    </InputWrapper>
  );
};

export default EditorInputBox;
